/**
 * Notifications Composable
 *
 * Provides toast notification helpers using PrimeVue's Toast service.
 */
import { useToast } from 'primevue/usetoast'

export function useNotifications() {
  const toast = useToast()

  /**
   * Show success notification
   */
  function showSuccess(summary: string, detail?: string, life = 3000): void {
    toast.add({
      severity: 'success',
      summary,
      detail,
      life,
    })
  }

  /**
   * Show info notification
   */
  function showInfo(summary: string, detail?: string, life = 3000): void {
    toast.add({
      severity: 'info',
      summary,
      detail,
      life,
    })
  }

  /**
   * Show warning notification
   */
  function showWarning(summary: string, detail?: string, life = 5000): void {
    toast.add({
      severity: 'warn',
      summary,
      detail,
      life,
    })
  }

  /**
   * Show error notification
   */
  function showError(summary: string, detail?: string, life = 5000): void {
    toast.add({
      severity: 'error',
      summary,
      detail,
      life,
    })
  }

  /**
   * Show sticky notification (must be dismissed manually)
   */
  function showSticky(
    severity: 'success' | 'info' | 'warn' | 'error',
    summary: string,
    detail?: string
  ): void {
    toast.add({
      severity,
      summary,
      detail,
      life: 0, // 0 makes it sticky (must be dismissed manually)
    })
  }

  /**
   * Clear all notifications
   */
  function clearAll(): void {
    toast.removeAllGroups()
  }

  return {
    showSuccess,
    showInfo,
    showWarning,
    showError,
    showSticky,
    clearAll,
  }
}
